export const AllowedCountryList = [
  'Norway',
  'Sweden',
  'Denmark',
  'Finland',
  'Iceland',
  'Faroe Islands'
]
